import { jsx as o } from "react/jsx-runtime";
import * as m from "react";
import { forwardRef as s } from "react";
import { P as f } from "./index-BrTLHETv.js";
import { c as d } from "./index-CYpVUGdk.js";
import { $ as n } from "./utils-CTvPli9r.js";
var c = "Label", i = m.forwardRef((e, t) => /* @__PURE__ */ o(
  f.label,
  {
    ...e,
    ref: t,
    onMouseDown: (a) => {
      var r;
      a.target.closest("button, input, select, textarea") || ((r = e.onMouseDown) == null || r.call(e, a), !a.defaultPrevented && a.detail > 1 && a.preventDefault());
    }
  }
));
i.displayName = c;
var l = i;
const u = d(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), b = s(({ className: e, ...t }, a) => /* @__PURE__ */ o(l, { ref: a, className: n(u(), e), ...t }));
b.displayName = l.displayName;
export {
  b as Label
};
//# sourceMappingURL=label.js.map
